var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.253332 2.67214L2.37333 4.60058C2.54222 4.85374 2.79111 5 3.05333 5L12.9378 5C13.2 5 13.4489 4.85374 13.6178 4.60059L15.7378 2.67214C15.9067 2.45837 16 2.17709 16 1.87894L16 0L0 -1.39876e-06L-1.6377e-07 1.87331C-1.89836e-07 2.17147 0.093334 2.45837 0.262223 2.66652L0.253332 2.67214ZM3.83333 6L12.1667 6C12.6269 6 13 6.44772 13 7L13 8C13 8.55229 12.6269 9 12.1667 9L3.83333 9C3.3731 9 3 8.55229 3 8L3 7C3 6.44771 3.3731 6 3.83333 6ZM4 10L11.9998 10L12 14.0705C12 16.2396 10.208 18 8.00008 18C5.79213 18 4.00017 16.2396 4.00017 14.0705L4 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenSmall);
export default __webpack_public_path__ + "static/media/pen-small.a39344ca28c530561ddb65f73cef47b1.svg";
export { ForwardRef as ReactComponent };